import { authClient } from '@metto/http-clients/api';

export const useSession = authClient.useSession;
